import Utils from '../../Utils.js';

export async function handleTextPaste(data, position) {
  const textContent = await data.text();
  Utils.insertSticky({ text: textContent, position });
}